import React from 'react';
import './index.style.less';
import PropTypes from 'prop-types';
import {useSidebarContext} from '../../../../utility/AppContextProvider/SidebarContextProvider';

const AppLogoAuth = ({hasSidebarColor}) => {
  const {sidebarColorSet} = useSidebarContext();
  return (
    <div className='app-logo'>
      {hasSidebarColor && sidebarColorSet.mode === 'dark' ? (
        <img src='/assets/images/logo_horizontal.svg' alt='democratrade-logo' />
      ) : (
        <img src='/assets/images/logo_horizontal.svg' alt='democratrade-logo' />
      )}
    </div>
  );
};

export default AppLogoAuth;

AppLogoAuth.propTypes = {
  hasSidebarColor: PropTypes.bool,
};
